// src/components/NewMenu/NewMenuPage.jsx
import React, { useState } from 'react';
import MenuIntro from './MenuIntro';
import MenuPopup from './MenuPopup';
import './menu.css';

export default function NewMenuPage(){
  const [open, setOpen] = useState(false);
  return (
    <section id="menu" className="vt-menu">
      <div className="vt-container">
        <MenuIntro onOpen={() => setOpen(true)} />
      </div>
      <MenuPopup open={open} onClose={() => setOpen(false)} />
    </section>
  );
}
